import React from 'react'
import req from '@sportninja/common/api/request'
// @ts-ignore Mixed JS module without declarations in this workspace.
import { store } from '@sportninja/common/store'
import { ActionType, ProfileAction } from '../context/ProfileContext/types'
import { ProfileUser } from '../types'

/**
 * Loads the current user profile, preferring Redux state before falling back to API.
 */
export const loadProfileItem = async (
  dispatch: React.Dispatch<ProfileAction>,
  forceApi = false
): Promise<void> => {
  if (!forceApi) {
    const reduxUser = store?.getState?.()?.auth?.user as ProfileUser | undefined
    if (reduxUser && reduxUser.id && reduxUser.name_first) {
      dispatch({ type: ActionType.SET_ITEM, payload: reduxUser })
      return
    }
  }

  try {
    const response = await req('/users/me2')
    dispatch({ type: ActionType.SET_ITEM, payload: response.data })
  } catch (error) {
    console.error('🚨 loadProfileItem: Failed to load profile item', error)
  }
}
